var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFolderMessage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "25px",
    viewBox: "0 0 31 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFolderMessage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification:-Saved-in-folder",
    transform: "translate(-25.000000, -87.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(6.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icFolderMessage",
    transform: "translate(19.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9,3.0931 L30.9,15.073 C30.9,16.6160333 29.5160271,17.8666667 27.8091063,17.8666667 L14.5958333,17.8666667 L8.325,24.1 L8.325,17.8666667 L3.89089375,17.8666667 C2.18397292,17.8666667 0.8,16.6160333 0.8,15.0735667 L0.8,3.09366667 C0.8,1.55063333 2.18397292,0.3 3.89089375,0.3 L27.8084792,0.3 C29.5160271,0.3 30.9,1.55063333 30.9,3.0931 Z M14.14375,7.3 C14.5066563,7.3 14.8,6.8296 14.8,6.25 C14.8,5.6704 14.5066563,5.2 14.14375,5.2 L4.95625,5.2 C4.59334375,5.2 4.3,5.6704 4.3,6.25 C4.3,6.8296 4.59334375,7.3 4.95625,7.3 L14.14375,7.3 Z M23.2241379,10.1 C23.5978897,10.1 23.9,9.6296 23.9,9.05 C23.9,8.4704 23.5978897,8 23.2241379,8 L4.97586207,8 C4.60211034,8 4.3,8.4704 4.3,9.05 C4.3,9.6296 4.60211034,10.1 4.97586207,10.1 L23.2241379,10.1 Z M23.2241379,13.6 C23.5978897,13.6 23.9,13.1296 23.9,12.55 C23.9,11.9704 23.5978897,11.5 23.2241379,11.5 L4.97586207,11.5 C4.60211034,11.5 4.3,11.9704 4.3,12.55 C4.3,13.1296 4.60211034,13.6 4.97586207,13.6 L23.2241379,13.6 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFolderMessage);
export default __webpack_public_path__ + "static/media/icFolderMessage.76dcf36b53d1ec9650c8ef9a0d985884.svg";
export { ForwardRef as ReactComponent };